<template>
<!-- Mobile Only -->
  <div class="page-title py-5 bg-custom-gradient position-relative">
    <!-- User -->
    <div class="user d-lg-none d-flex mt-5 align-items-center justify-content-center flex-column position-absolute top-100 start-50 translate-middle w-100 px-3">
      <div class="avatar mt-lg-0 mt-3 position-relative">
        <img src="@/assets/images/msaaq.svg" width="152" alt="" />
      </div>
      <div class="d-flex align-items-center mt-1">
        <div class="fs-6 text-primary fw-bold">مساق</div>
      </div>
      <div class="fs-14px text-secondary text-center mb-5">هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى</div>
    </div>
  </div>
  <!-- End mobile -->

  <div class="container">
    <!-- Mobile -->
    <div class="clearfix d-lg-none d-block"></div>
    <div class="d-lg-none d-block border-top border-2 my-3"></div>
    <!-- end Mobile only -->
    <div class="my-lg-5 my-0"></div>
    <div class="row gap-3 meeting-body pb-lg-3">
      <div class="col-12 mx-auto px-0">
        <!-- Desktop Only -->
        <div class="bg-custom-gradient meeting-card d-lg-flex d-none align-items-center gap-3 py-3">
          <img src="@/assets/images/userbig.png" class="mx-3" width="90" alt="">
          <div class="d-flex flex-column">
            <span class="fs-4 text-white fw-bold">مدحت عودة</span>
            <span class="fs-14px text-white w-75">هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى</span>
          </div>
        </div>
      </div>
        <div class="radio-group overflow-scroll days-radio btn-group d-flex justify-content-between gap-2" role="group" aria-label="Basic radio toggle button group">
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check btn-disabled" name="btnradio" id="btnradio1" autocomplete="off" checked />
            <label class="btn bg-white border rounded-12px days-radio-item border-2 d-flex flex-column align-items-center justify-content-center" for="btnradio1">
              <span class="text-secondary fs-14px">السبت</span>
              <span class="text-dark fs-4">11</span>
            </label>
          </div>
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" />
            <label class="btn bg-white border rounded-12px days-radio-item border-2 d-flex flex-column align-items-center justify-content-center" for="btnradio2">
              <span class="text-secondary fs-14px">الاحد</span>
              <span class="text-dark fs-4">12</span>
            </label>
          </div>
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off" />
            <label class="btn bg-white border rounded-12px days-radio-item border-2 d-flex flex-column align-items-center justify-content-center" for="btnradio3">
              <span class="text-secondary fs-14px">الاثنين</span>
              <span class="text-dark fs-4">13</span>
              <div class="bg-success status-circle mb-0" style="width: 5px; height: 5px"></div>
            </label>
          </div>
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio4" autocomplete="off" />
            <label class="btn bg-white border rounded-12px days-radio-item border-2 d-flex flex-column align-items-center justify-content-center" for="btnradio4">
              <span class="text-secondary fs-14px">الثلاثاء</span>
              <span class="text-dark fs-4">14</span>
              <div class="bg-success status-circle mb-0" style="width: 5px; height: 5px"></div>
            </label>
          </div>
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio5" autocomplete="off" />
            <label class="btn bg-white border rounded-12px days-radio-item border-2 d-flex flex-column align-items-center justify-content-center" for="btnradio5">
              <span class="text-secondary fs-14px">الاربعاء</span>
              <span class="text-dark fs-4">15</span>
              <div class="bg-success status-circle mb-0" style="width: 5px; height: 5px"></div>
            </label>
          </div>
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio6" autocomplete="off" />
            <label class="btn bg-white border rounded-12px days-radio-item border-2 d-flex flex-column align-items-center justify-content-center" for="btnradio6">
              <span class="text-secondary fs-14px">الخميس</span>
              <span class="text-dark fs-4">16</span>
              <div class="bg-success status-circle mb-0" style="width: 5px; height: 5px"></div>
            </label>
          </div>
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio7" autocomplete="off" />
            <label class="btn bg-white border rounded-12px days-radio-item border-2 d-flex flex-column align-items-center justify-content-center" for="btnradio7">
              <span class="text-secondary fs-14px">الجمعة</span>
              <span class="text-dark fs-4">17</span>
              <div class="bg-success status-circle mb-0" style="width: 5px; height: 5px"></div>
            </label>
          </div>
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio8" autocomplete="off" />
            <label class="btn bg-white border rounded-12px days-radio-item border-2 d-flex flex-column align-items-center justify-content-center" for="btnradio8">
              <span class="text-secondary fs-14px">السبت</span>
              <span class="text-dark fs-4">18</span>
              <div class="bg-success status-circle mb-0" style="width: 5px; height: 5px"></div>
            </label>
          </div>
        </div>
        <div class="mt-4">
          <h5 class="text-dark fw-bold fs-14px">قم بتحديد الوقت المناسب</h5>
          <div>
            تم تحديد المنطقة الزمنية حسب غرينتش
            <button type="button" class="btn p-0 fw-bold text-primary text-decoration-underline" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">تعديل المنطقة الزمنية</button>
          </div>
          <div class="collapse" id="collapseExample">
            <div class="card card-body bg-transparent border-0 p-0 pt-3">
              <select class="form-select py-2 rounded-12px border-2 text-secondary">
                <option value="">اختر التوقيت</option>
                <option value="">غرينتش</option>
              </select>
            </div>
          </div>
        </div>

      <div class="col-lg-4 col-12 mb-3">
        <router-link :to="{name:'MeetingEdit'}" class="text-decoration-none bg-white d-flex px-3 py-lg-0 py-3 rounded-12px border border-2">
          <div class="d-flex flex-column">
            <span class="fs-4 fw-normal">12:00</span>
            <span class="fs-12px text-secondary">حسب توقيته المحلي 02:00</span>
          </div>
          <img src="@/assets/images/chevron-right.svg" alt="" class="ms-auto" />
        </router-link>
      </div>
      <div class="col-lg-4 col-12 mb-3">
        <router-link :to="{name:'MeetingEdit'}" class="text-decoration-none bg-white d-flex px-3 py-lg-0 py-3 rounded-12px border border-2">
          <div class="d-flex flex-column">
            <span class="fs-4">12:00</span>
            <span class="fs-12px text-secondary">حسب توقيته المحلي 02:00</span>
          </div>
          <img src="@/assets/images/chevron-right.svg" alt="" class="ms-auto" />
        </router-link>
      </div>
      <div class="col-lg-4 col-12 mb-3">
        <router-link :to="{name:'MeetingEdit'}" class="text-decoration-none bg-white d-flex px-3 py-lg-0 py-3 rounded-12px border border-2">
          <div class="d-flex flex-column">
            <span class="fs-4">12:00</span>
            <span class="fs-12px text-secondary">حسب توقيته المحلي 02:00</span>
          </div>
          <img src="@/assets/images/chevron-right.svg" alt="" class="ms-auto" />
        </router-link>
      </div>
      <div class="col-lg-4 col-12 mb-3">
        <router-link :to="{name:'MeetingEdit'}" class="text-decoration-none bg-white d-flex px-3 py-lg-0 py-3 rounded-12px border border-2">
          <div class="d-flex flex-column">
            <span class="fs-4">12:00</span>
            <span class="fs-12px text-secondary">حسب توقيته المحلي 02:00</span>
          </div>
          <img src="@/assets/images/chevron-right.svg" alt="" class="ms-auto" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from '@vue/reactivity'
export default {
  name: 'Edit',
  setup() {
    const showDatepicker = ref(true)
    const attributes = ref([
      {
        highlight: {
          backgroundColor: '#1ebb42',
          borderRadius: '5px',
          borderColor: '#1ebb42',
          borderWidth: '4px',
        },
        dot: {
          class: 'bg-success', // Red dot
        },
        dates: [
          new Date(2022, 1, 1), // Feb 6th
          new Date(2022, 1, 2), // Feb 16th
          new Date(2022, 1, 3), // Feb 16th
          new Date(2022, 1, 4), // Feb 16th
          new Date(2022, 1, 5), // Feb 16th
          new Date(2022, 1, 6), // Feb 16th
          new Date(2022, 1, 7), // Feb 16th
          new Date(2022, 1, 8), // Feb 16th
        ],
      },
    ])
    return {showDatepicker, attributes}
  },
}
</script>

<style>
</style>